import { Observable } from 'rxjs';
import { IMaterial } from './learn-engine-api.interface';

export interface ILandingPageApi {
    getLandingPage: (alias: string) => Observable<ILandingPageResponse>;
}
export interface ILandingPageResponse {
    metaData: ILandingPageMetaData[];
    sections: ILandingPageSections[];
}

export interface ILandingPageMetaData {
    name: ILandingPageMetaType;
    content: string;
}

export enum ILandingPageMetaType {
    description = 'description',
    title = 'title',
    imgUrl = 'imgUrl',
}

export enum LandingPageSection {
    Header = 'header',
    WhatYouLearn = 'what_you_learn',
    CourseDescription = 'course_description',
    ReasonsSection = 'reasons_section',
    TestimonialsSection = 'testimonials_section',
    BlogSection = 'blog_section',
    Footer = 'footer',
    CourseSection = 'course_section',
    GoogleHire = 'google_hire',
    WhyAngular = 'why_angular',
    WhySololearn = 'why_sololearn',
    WhatYouLearnAngular = 'what_you_learn_angular',
    AngularCourseContent = 'angular_course_content',
    AngularCourseFooter = 'angular_course_footer',
    AICourseSkills = 'ai_course_skills',
}

export type LandingPageData =
    | ILPHeaderData
    | ILPWhatYouLearnData
    | ILPCourseDescriptionData
    | IMaterial
    | ILPTestimonialsData
    | ILPBlogData
    | ILPReasonsData
    | ILPGoogleHireData
    | ILPWhyAngularData
    | ILPWhySololearnData
    | ILPWhatYouLearnAngularData
    | ILPAngularCourseContentData
    | ILPAngularCourseFooterData;

export interface ILandingPageSections {
    pageId: number;
    pageName: string;
    data: LandingPageData;
}

export interface ILPHeaderData {
    headerInfo: {
        courseLogo: string;
    };
}

export interface IReasonItem {
    id: number;
    title: string;
    text: string;
    imgUrl: string;
}

export interface ILPReasonsData {
    title: string;
    actionBtnText: string;
    reasons: IReasonItem[];
}

export interface ILearnThemeItem {
    id: number;
}

export interface ILPWhatYouLearnData {
    imgUrl: string;
    themes: ILearnThemeItem[];
}

export interface ILPCourseDescriptionData {
    title: string;
    description: string;
}

export interface IFeedbackItem {
    id: number;
    feedback: string;
    author: string;
}

export interface ILPTestimonialsData {
    actionBtnText: string;
    title: string;
    feedbacks: IFeedbackItem[];
}

export interface IBlogCard {
    id: string;
    imgUrl: string;
}

export interface ILPBlogData {
    blogItems: IBlogCard[];
}

export interface ILPGoogleHireData {
    imgUrl: string;
}

export interface ILPWhyAngularData {
    items: {
        imgUrl: string;
    }[];
}

export interface ILPWhySololearnData {
    items: {
        imgUrl: string;
    }[];
}

export interface ILPWhatYouLearnAngularData {
    items: { title: string }[];
    imgUrl: string;
}

export interface ILPAngularCourseContentData {
    title: string;
    description: string;
    courses: {
        title: string;
        subtree: IMaterial;
        jumpTo: string;
    }[];
}

export interface ILPAngularCourseFooterData {
    imgUrl: string;
}
